import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { setAddingToCartFlowAction } from '../slice';
import { AddToCartFlow } from '../types';
import getSelectedBundleProducts from '../selector/getSelectedBundleProducts';
import getLastOrderItemId from '../selector/getLastOrderItemId';
import getProductQuantity from '../selector/getProductQuantity';

const addToBasketSelectedBundleProductsOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const lastOrderItemId = getLastOrderItemId(store);
    const quantity = getProductQuantity(store);

    if (!lastOrderItemId) {
      return Promise.resolve(false);
    }
    const selectedBundleProducts = getSelectedBundleProducts(store).filter(
      (selectedProduct) => selectedProduct.productId > 0,
    );

    if (!selectedBundleProducts.length) {
      return Promise.resolve(false);
    }

    dispatch(setAddingToCartFlowAction(AddToCartFlow.bundlingProduct));

    return Promise.all(
      selectedBundleProducts.map((selectedProduct) =>
        apiRequest(
          endpoints.cartV1ProductAdd,
          {
            bundleOwnerOrderItemId: lastOrderItemId,
            categoryId: selectedProduct.categoryId,
            includeAnalytics: true,
            productId: selectedProduct.productId,
            quantity,
          },
          HttpMethods.POST,
          'data',
        ),
      ),
    )
      .then(() => {
        dispatch(setAddingToCartFlowAction(AddToCartFlow.bundlingCompleted));
      })
      .catch(() => {
        dispatch(setAddingToCartFlowAction(AddToCartFlow.bundlingFailed));
      });
  };

export default addToBasketSelectedBundleProductsOperation;
